import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import Card from "../../components/Card";
import { toast } from "mdbreact";
import ProductSkeleton from "../../components/PageLoading/ProductSkeleton";

import {
  getParamValues,
  getDefValues,
  getCurrentCatalog,
  callApiV2,
  buildProductsCard,
} from "../../common/functions";

const initialSearchData = {
  searchinput: "",
  results: [],
  showtype: "grid",
  showresults: true,
  categories: [],
  showcategories: false,
  listcategories: true,
  selectedcategories: [],
  options: [],
  noresults: null,
  minprice: 0,
  maxprice: 0,
  minpricedef: 0,
  maxpricedef: 0,
  listprices: true,
  reloadpage: false,
};
const initialCardConfig = {
  pagesettings: {
    itemsperpage: 15,
    currentPage: 1,
  },
};
const maxItemsFilter = getParamValues().maxItemsFilter;
var timeout = null;
const Search = (props) => {
  const [fistTime, setFistTime] = React.useState(true);

  const [totalRows, setTotalRows] = React.useState(null);
  const [size, setSize] = React.useState(0);
  const [hasMore, setHasMore] = React.useState(false);
  const [cardData, setCardData] = React.useState([]);
  const [cardConfig, setCardConfig] = React.useState(initialCardConfig);
  const [from, setFrom] = React.useState(1);
  const [isLoadingP, setIsLoadingP] = React.useState(false);
  const [productNotFounded, setProductNotFounded] = React.useState(true);
  const [searchinput, setSearchinput] = React.useState("");

  const [searchData, setSearchData] = React.useState(initialSearchData);

  React.useEffect(() => {

    let value = "";

    const pathname = window.location.pathname;
    const parts = pathname.split("/");
    // Ej:
    // "" "search" "molde"
    // "" "molde"

    // 1) Leer ?key=molde
    const query = new URLSearchParams(window.location.search);
    const queryKey = query.get("key");

    // 2) Path param dentro de /search/:key
    let pathKey = "";
    if (parts[1] === "search" && parts.length >= 3) {
      pathKey = parts[2]; // molde
    }

    // 3) NotFound: /molde (ruta directa)
    let notFoundKey = "";
    // Cuando la ruta es: /algo
    if (parts.length === 2 && parts[1] !== "" && parts[1] !== "search") {
      notFoundKey = parts[1];
    }

    // Orden de prioridad:
    // query param > /search/:key > /:notfound
    value = queryKey || pathKey || notFoundKey || "";

    if (value && searchinput === "" && fistTime) {
      changeHandlerS({ target: { name: "key", value } });
      setSearchinput(value);
      setFistTime(false);
    } else {
      setFistTime(false);
    }
  }, [props]);

  const clearData = () => {
    setCardData([]);
    setCardConfig(initialCardConfig);
    setTotalRows(null);
    setHasMore(false);
    setFrom(1);
    setSize(0);
  };

  const changeHandlerS = (event) => {
    if (event.target.value !== searchinput) {
      setSearchinput(event.target.value);
      if (event.target.value.length < 3) {
        setSearchData(initialSearchData);
      } else {
        clearTimeout(timeout);
        setIsLoadingP(true);
        timeout = setTimeout(async function () {
          clearData();
          console.log("buscando...");
          await getProducts(from, false, event.target.value);
          setIsLoadingP(false);
        }, 350);
      }
    }
  };

  const fetchMoreData = async () => {
    //console.log("fetchMoreData", cardData.length, totalRows);
    await getProducts(from, true, searchinput);
  };
  const getProducts = async (page, isAdding, searchinput) => {
    try {
      //console.log("getProducts", hasMore, page, cardData.length);
      //setIsLoadingP(true);
      let itemsperpage = cardConfig.pagesettings.itemsperpage;
      if (props.windowWidth < 799) {
        itemsperpage = 10;
      } else {
        itemsperpage = 12;
      }
      let _from = (page - 1) * itemsperpage;
      //console.log("from", _from);
      var data = {
        languageid: 3,
        searchkey: searchinput,
        storeid: getCurrentCatalog(),
        size: itemsperpage,
        from: _from,
      };
      var resp = await callApiV2("customer", "getFilterProducts", data);
      if (resp.rows.length <= 0) {
        //setIsLoadingP(false);
        setProductNotFounded(true);
        setHasMore(false);
      } else {
        //console.log("resp", resp);
        let prodDefConfig = {
          pagewidth: "col-md-12 col-lg-12 col-xl-12",
          colsize: "col-6",
          colsizelg: "col-lg-4",
          colsizemd: "col-md-6",
          colsizesm: "col-sm-6",
          limit: 1000,
        };
        let respCat = await buildProductsCard(
          resp,
          cardConfig.pagesettings,
          null, //ANTES this.managepagination,
          null, //ANTES this.manageCart,
          prodDefConfig,
          "categories",
          null, //categoryRouteObj,
          null, //categoryid,
          toast
        );

        let _cardConfig = respCat.cardConfig;
        delete _cardConfig["managepagination"];
        _cardConfig["mobile"] = true;
        if (isAdding) {
          setCardData([...cardData, ...respCat.cardProducts]);
        } else {
          setCardData(respCat.cardProducts);
        }
        if (size < resp.meta.total && resp.meta.total > 10) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
        setCardConfig(_cardConfig);
        setTotalRows(resp.meta.total);
        setSize(size + resp.rows.length);
        setFrom(from + 1);
        //setIsLoadingP(false);
      }
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
    } finally {
      //setIsLoadingP(false);
    }
  };

  return (
    <div className="content custom-container container-page container-fluid container-page">
      <div className="row row-top mb-2 mt-2">
        <div className="col-12 flex items-center text-center hide-mobile">
          <div
            className="h1-responsive mb-2 mt-30"
            style={{ textAlign: "center" }}
          >
            {getDefValues().searchTitleLabel}
          </div>
        </div>
      </div>
      <div className="row row-top mb-2 mt-2">
        <div className="col-12 flex items-center text-center hide-mobile">
          <div className="search-style-n">
            <div style={{ justifyContent: "center" }}>
              <input
                type="text"
                name="key"
                ref={(input) =>
                  input && props.mobileFirstTime ? input.focus() : ""
                }
                value={searchinput}
                onChange={changeHandlerS}
                onKeyDown={changeHandlerS}
                className="search-web"
                placeholder={getDefValues().searchLabel}
              />
            </div>
          </div>
        </div>
      </div>

      {searchData.showresults ? (
        <div className="row">
          <div className="col-12">
            <div className={"container search-container"}>
              <div className="row mb-4">
                <div className="col col-3 col-cat">
                  <div className="col-cat-content">
                    {searchData.listcategories ? (
                      <>
                        <ul className="categories">
                          {searchData.categories.map((item, i) =>
                            searchData.showcategories || i < maxItemsFilter ? (
                              <li
                                className={
                                  searchData.selectedcategories.indexOf(
                                    "" + item.categoryid
                                  ) >= 0
                                    ? "active"
                                    : ""
                                }
                              >
                                <button
                                  name={"filter_categories_" + item.categoryid}
                                  onClick={props.manageSearch}
                                  className="btn btn-sm name searcher-mobile-button "
                                >
                                  {item.categoryname}
                                </button>
                                <button
                                  name={"filter_categories_" + item.categoryid}
                                  onClick={props.manageSearch}
                                  className="btn btn-sm quantity searcher-mobile-button"
                                >
                                  {item.quantity}
                                </button>
                              </li>
                            ) : (
                              ""
                            )
                          )}
                        </ul>
                        {!searchData.showcategories &&
                          searchData.categories.length > maxItemsFilter ? (
                          <div className="flex items-center">
                            <button
                              name="show_showcategories"
                              onClick={props.manageSearch}
                              className="btn btn-sm searcher-mobile-button"
                            >
                              {getDefValues().showMoreLabel}
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                        {searchData.showcategories &&
                          searchData.categories.length > maxItemsFilter ? (
                          <div className="flex items-center">
                            <button
                              name="hide_showcategories"
                              onClick={props.manageSearch}
                              className="btn btn-sm searcher-mobile-button"
                            >
                              {getDefValues().hideLabel}
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    {searchData.options.length > 0
                      ? searchData.options.map((item, i) => (
                        <div className="mt-2 mb-2">
                          <ul className="categories">
                            <li className="">
                              <button
                                name={"toggle_listoptions_" + item.optionid}
                                onClick={props.manageSearch}
                                className="btn btn-sm title-name searcher-mobile-button"
                              >
                                {item.optionname}
                                {item.selectedoptions.length > 0
                                  ? " (" + item.selectedoptions.length + ")"
                                  : ""}
                              </button>

                              <button
                                name={"toggle_listoptions_" + item.optionid}
                                onClick={props.manageSearch}
                                className="btn btn-sm title-button searcher-mobile-button"
                              >
                                <i
                                  className={
                                    "fas " +
                                    (item.listoptions
                                      ? "fa-minus"
                                      : "fa-plus")
                                  }
                                />
                              </button>
                            </li>
                          </ul>

                          {item.listoptions ? (
                            <>
                              <ul className="categories">
                                {item.options.map((option, i) =>
                                  item.showoptions || i < maxItemsFilter ? (
                                    <li
                                      className={
                                        item.selectedoptions.indexOf(
                                          "" + option.value
                                        ) >= 0
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <button
                                        name={
                                          "filter_options_" +
                                          item.optionid +
                                          "_" +
                                          option.value
                                        }
                                        onClick={props.manageSearch}
                                        className="btn btn-sm name searcher-mobile-button "
                                      >
                                        {option.value}
                                      </button>
                                      <button
                                        name={
                                          "filter_options_" +
                                          item.optionid +
                                          "_" +
                                          option.value
                                        }
                                        onClick={props.manageSearch}
                                        className="btn btn-sm quantity searcher-mobile-button"
                                      >
                                        {option.quantity}
                                      </button>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                )}
                              </ul>
                              {!item.showoptions &&
                                item.options.length > maxItemsFilter ? (
                                <div className="flex items-center">
                                  <button
                                    name={"show_showoptions_" + item.optionid}
                                    onClick={props.manageSearch}
                                    className="btn btn-sm searcher-mobile-button"
                                  >
                                    {getDefValues().showMoreLabel}
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                              {item.showoptions &&
                                item.options.length > maxItemsFilter ? (
                                <div className="flex items-center">
                                  <button
                                    name={"hide_showoptions_" + item.optionid}
                                    onClick={props.manageSearch}
                                    className="btn btn-sm searcher-mobile-button"
                                  >
                                    {getDefValues().hideLabel}
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            ""
                          )}
                          {item.selectedoptions.length > 0 &&
                            !item.listoptions ? (
                            <>
                              <ul className="categories">
                                {item.options.map((option, i) =>
                                  item.selectedoptions.indexOf(
                                    "" + option.value
                                  ) >= 0 ? (
                                    <li className="active">
                                      <button
                                        name={
                                          "filter_options_" +
                                          item.optionid +
                                          "_" +
                                          option.value
                                        }
                                        onClick={props.manageSearch}
                                        className="btn btn-sm name searcher-mobile-button "
                                      >
                                        {option.value}
                                      </button>
                                      <button
                                        name={
                                          "filter_options_" +
                                          item.optionid +
                                          "_" +
                                          option.value
                                        }
                                        onClick={props.manageSearch}
                                        className="btn btn-sm quantity "
                                      >
                                        {option.quantity}
                                      </button>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                )}
                              </ul>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ))
                      : ""}
                  </div>
                </div>
                <div className="col col-9 col-list ">
                  <div className="list-header">
                    <div>
                      {" "}
                      {getDefValues().resultsLabel.toUpperCase() +
                        ": " +
                        cardData.length}
                    </div>
                  </div>
                  <span className="or-line mt-2"></span>

                  {searchData.noresults ? (
                    <span className="flex items-center">
                      {searchData.noresults}{" "}
                    </span>
                  ) : (
                    ""
                  )}

                  <div className="row">
                    {isLoadingP ? (
                      <>
                        {Array.from({
                          length: 3,
                        }).map((_, i) => (
                          <div
                            key={i}
                            className="col-6 col-sm-6 col-md-4 col-lg-4 mobile-col d-flex"
                          >
                            <ProductSkeleton />
                          </div>
                        ))}
                      </>
                    ) : (
                      <InfiniteScroll
                        dataLength={cardData.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={
                          <>
                            <div className="row">
                              {Array.from({
                                length: 3,
                              }).map((_, i) => (
                                <div
                                  key={i}
                                  className="col-6 col-sm-6 col-md-4 col-lg-4 mobile-col d-flex"
                                >
                                  <ProductSkeleton />
                                </div>
                              ))}
                            </div>
                          </>
                        }
                        endMessage={""}
                      >
                        <Card cardData={cardData} cardConfig={cardConfig} />
                      </InfiniteScroll>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Search;
